import isNil from 'lodash/isNil';

import { StepCategory } from '../../types/app_data';
import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';

import { doesLoadingStepHaveToShowOrNot } from './loading.step';

export const SkipLNStep: Step = {
  // Ask if user is insured for multiple drivers and cars
  id: 'skipLN',
  pathname: '/multiplecarsdrivers',
  canShow: (appData: AppData) => {
    const haveToPullDataOrNot = doesLoadingStepHaveToShowOrNot(appData);
    // It has been determined that the loading step should be shown or not, so no need to ask this question.
    if (typeof haveToPullDataOrNot === 'boolean') {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    if (appData.selectedService?.insurance) {
      if (appData.isOnboardingLite) {
        return false;
      }
      return true;
    }
    return false;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !isNil(appData.signupParams?.multipleCarsAndDrivers),
  category: () => StepCategory.Cars,
};
